import { notification } from 'antd';
import { queryRechargeHisBsnl, genCaptcha, qryConfigParams } from '@pages/OnlinePayment/ReceiptCaptcha/services';
import { get, isEmpty } from 'lodash';
import { getRequestData } from '@/utils';

const initState = {
  imgReturn: {},
  rechargeList: {},
  configParams: {},
};

export default {
  namespace: 'queryReceiptInformation',
  state: {
    ...initState,
  },
  effects: {
    // 根据号码查询账单信息
    *queryRechargeHisBsnl({ payload }, { call, put }) {
      const response = yield call(queryRechargeHisBsnl, payload);
      const { rechargeDtoList, ApiResponse, returnCode } = getRequestData(response);
      if (returnCode !== '0') {
        return false;
      }
      if (!isEmpty(ApiResponse) || !rechargeDtoList || (rechargeDtoList && rechargeDtoList.length <= 0)) {
        !isEmpty(ApiResponse) ? notification.error({
          message: 'Error',
          description: get(ApiResponse, 'resultDesc'),
        }) : notification.error({
          message: 'Error',
          description: 'No data',
        });
        return false;
      }
      yield put({
        type: 'save',
        payload: {
          rechargeList: rechargeDtoList[0],
        },
      });
      return rechargeDtoList[0];
    },

    // 生成图形验证码
    *genCaptcha(_, { call, put }) {
      const response = yield call(genCaptcha);
      const { imgCode, imgToken } = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          imgReturn: {
            imgCode,
            imgToken,
          },
        },
      });
    },

    *qryConfigParams({ payload }, { call, put }) {
      const response = yield call(qryConfigParams, payload);
      const paramsList = getRequestData(response);
      const paramsObj = {};
      if (!isEmpty(paramsList)) {
        paramsList.forEach(item => {
          if (item) {
            paramsObj[item.paramCode] = item.paramValue || item.defaultValue;
          }
        });
      }

      yield put({
        type: 'save',
        payload: { configParams: paramsObj },
      });
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return {
        ...initState,
      };
    },
  },
};
